export enum DonationFrequency {
	Monthly = 'monthly',
	OneTime = 'once',
	Unselected = ''
}
